export default function MobileRiskSquare({riskMetric, text}) {
  return (
    <>
      <h4 className="text-white font-extrabold text-xs text-center px-1">{text}</h4>
      <p className={`text-3xl font-extrabold text-center`}>
        {riskMetric}
      </p>
    </>
  )
}